// extracted by mini-css-extract-plugin
module.exports = {"pane":"pane__FiW1V","button-wrapper":"button-wrapper__1Wdrs","button":"button__1nZKd","text":"text__rYnMz","body":"body__NyqQg"};